import DEPRECATED_reducers from '~/reducers';

import '../api';
import { atlas } from '../api/atlas';
import { api } from '../api/createApi';
import { esign } from '../api/esign';
import { everest } from '../api/everest';
import { evisearch } from '../api/evisearch';
import { hermes } from '../api/hermes';
import { k2 } from '../api/k2';
import { managedEntities } from '../api/managed-entities';
import { rolodex } from '../api/rolodex';
import { sylvanus } from '../api/sylvanus';
import { unifiedFields } from '../api/unified-fields';
import { weaver } from '../api/weaver';
import aiWorkflowBuilds from './ai-workflow-builds';
import alerts from './alerts';
import analyzer from './analyzer';
import automation from './automation';
import chatbot from './chatbot';
import clauseLibrary from './clauseLibrary';
import clients from './clients';
import currentUser from './current-user';
import dashboardV2 from './dashboardV2';
import dataFields from './data-fields';
import myDeletedItems from './deleted-items';
import deprecatedUpload from './deprecated-upload';
import documentEditors from './documentEditors';
import documents from './documents';
import documentsNavigation from './documentsNavigation';
import documentsViewPage from './documentsViewPage';
import dynamicDataExtraction from './dynamic-data-extraction';
import esignature from './eSignature';
import i18n from './i18n';
import integrations from './integrations';
import moreSettings from './moreSettings';
import newIntegrations from './new-integrations';
import pages from './pages';
import restorationHub from './restoration-hub';
import savedDashboards from './saved-dashboards';
import search from './search';
import searchV3 from './searchV3';
import turnTracking from './turn-tracking';
import upload from './upload';
import webhooks from './webhooks';
import xRay from './x-ray';
import xRayDebug from './x-ray/debug';
import xRayLibrary from './x-ray/library';

const { addEditor, removeEditor, setEditors, setIsCurrentTabEditing } =
  documentEditors.actions;

const { setCurrentDocument } = documentsNavigation.actions;

export const actions = {
  // document editors
  addEditor,
  removeEditor,
  setEditors,
  setIsCurrentTabEditing,
  // Document Navigation
  setCurrentDocument,
};

export const reducer = {
  ...DEPRECATED_reducers,
  [api.reducerPath]: api.reducer,
  [k2.reducerPath]: k2.reducer,
  [unifiedFields.reducerPath]: unifiedFields.reducer,
  [esign.reducerPath]: esign.reducer,
  [everest.reducerPath]: everest.reducer,
  [evisearch.reducerPath]: evisearch.reducer,
  [managedEntities.reducerPath]: managedEntities.reducer,
  [hermes.reducerPath]: hermes.reducer,
  [sylvanus.reducerPath]: sylvanus.reducer,
  [rolodex.reducerPath]: rolodex.reducer,
  [weaver.reducerPath]: weaver.reducer,
  [atlas.reducerPath]: atlas.reducer,
  [aiWorkflowBuilds.name]: aiWorkflowBuilds.reducer,
  [alerts.name]: alerts.reducer,
  [analyzer.name]: analyzer.reducer,
  [automation.name]: automation.reducer,
  [chatbot.name]: chatbot.reducer,
  [clients.name]: clients.reducer,
  [clauseLibrary.name]: clauseLibrary.reducer,
  [currentUser.name]: currentUser.reducer,
  [dataFields.name]: dataFields.reducer,
  [dashboardV2.name]: dashboardV2.reducer,
  [deprecatedUpload.name]: deprecatedUpload.reducer,
  [dynamicDataExtraction.name]: dynamicDataExtraction.reducer,
  [documents.name]: documents.reducer,
  [documentEditors.name]: documentEditors.reducer,
  [documentsViewPage.name]: documentsViewPage.reducer,
  [documentsNavigation.name]: documentsNavigation.reducer,
  [esignature.name]: esignature.reducer,
  [i18n.name]: i18n.reducer,
  [integrations.name]: integrations.reducer,
  [myDeletedItems.name]: myDeletedItems.reducer,
  [moreSettings.name]: moreSettings.reducer,
  [newIntegrations.name]: newIntegrations.reducer,
  [pages.name]: pages.reducer,
  [restorationHub.name]: restorationHub.reducer,
  [savedDashboards.name]: savedDashboards.reducer,
  [search.name]: search.reducer,
  [searchV3.name]: searchV3.reducer,
  [turnTracking.name]: turnTracking.reducer,
  [upload.name]: upload.reducer,
  [webhooks.name]: webhooks.reducer,
  [xRay.name]: xRay.reducer,
  [xRayDebug.name]: xRayDebug.reducer,
  [xRayLibrary.name]: xRayLibrary.reducer,
};

export const slices = {
  aiWorkflowBuilds,
  alerts,
  analyzer,
  automation,
  chatbot,
  clauseLibrary,
  clients,
  currentUser,
  dataFields,
  dashboardV2,
  deprecatedUpload,
  dynamicDataExtraction,
  documents,
  documentsViewPage,
  esignature,
  i18n,
  integrations,
  newIntegrations,
  moreSettings,
  pages,
  restorationHub,
  upload,
  turnTracking,
  webhooks,
  myDeletedItems,
  savedDashboards,
  searchV3,
  xRay,
  xRayDebug,
  xRayLibrary,
};
